/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.payments.payment.method.management.rpc.PaymentMethodOnFileReadService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './PaymentMethodOnFileReadService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.payments.payment.method.management.rpc.PaymentMethodOnFileReadService#getActivePaymentMethodOnFileListForContact
 */
export const GET_ACTIVE_PAYMENT_METHOD_ON_FILE_LIST_FOR_CONTACT_QUERY_FIELD_NAME = 'com_hubspot_payments_payment_method_management_rpc_PaymentMethodOnFileReadService_getActivePaymentMethodOnFileListForContact';
export const GET_ACTIVE_PAYMENT_METHOD_ON_FILE_LIST_FOR_CONTACT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_ACTIVE_PAYMENT_METHOD_ON_FILE_LIST_FOR_CONTACT_QUERY_FIELD_NAME,
  args: ['contactId', 'filterOutNotChargeable'],
  fetcher(request, ctx) {
    return chirpClient.call(References.getActivePaymentMethodOnFileListForContactRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});